import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import {
  BG_STYLES,
  Button,
  BUTTON_STATUS,
  BUTTON_TYPE,
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  SIZE,
  TEXT_STYLES,
} from "@dehaat/dds";
import RequestInfo from "./RequestInfo";
import ApproveIcon from "app/icons/Approve";
import { PriceChangeRequest } from "app/models/RequestFlow";
import BouncyCheckbox from "react-native-bouncy-checkbox";
import { useSelector } from "react-redux";
import { selectRoleType } from "app/store/reducer/requestflow";
import { RoleType, STATUS } from "app/constants/request";

type RequestCardProps = {
  item: PriceChangeRequest;
  onPress: () => void;
  onApprove: () => void;
  onReject: () => void;
  isMultiSelect?: boolean;
  isSelected?: boolean;
  onToggleSelect?: (itemId: string | number) => void;
};

const RequestCard = ({
  item,
  onPress,
  onApprove,
  onReject,
  isMultiSelect = false,
  isSelected = false,
  onToggleSelect
}: RequestCardProps) => {
  const roleType = useSelector(selectRoleType);
  const canTakeAction =
    (roleType === RoleType.L1 && item.latest_status === STATUS.L1_PENDING) ||
    (roleType === RoleType.L2 && item.latest_status === STATUS.L2_PENDING);
  return (
    <Pressable
      style={[
        styles.card,
      ]}
      onPress={onPress}
    >
      {isMultiSelect && canTakeAction&& (
        <View style={styles.checkboxContainer}>
          <BouncyCheckbox
            isChecked={isSelected}
            onPress={() => onToggleSelect && onToggleSelect(item.id)}
            size={20}
            fillColor={COLORS.primary100}
            iconStyle={styles.checkbox}
            innerIconStyle={styles.checkbox}
          />
        </View>
      )}
      <RequestInfo item={item} />
      {!isMultiSelect && canTakeAction && (
        <View style={[COMMON_STYLES.row, COMMON_STYLES.justifyBetween,COMMON_STYLES.mt1 ,{ gap: 12 }]}>
          <Button
            buttonStyle={[
              BG_STYLES.bgError10,
              COMMON_STYLES.flex1,
              {paddingVertical: 20, borderColor: "transparent" }
            ]}
            onClick={onReject}
            type={BUTTON_TYPE.PRIMARY}
            text="Reject"
            size={SIZE.small}
            status={BUTTON_STATUS.ACTIVE}
            textStyle={[TEXT_STYLES.textError100]}
            iconLeft={
              <CrossIcon height={16} width={16} strokeColor={'error100'} />
            }
          />
          <Button
            buttonStyle={[
              BG_STYLES.bgPrimary10,
              { flex: 1, paddingVertical: 20, borderColor: "transparent" }
            ]}
            onClick={onApprove}
            type={BUTTON_TYPE.PRIMARY}
            text="Approve"
            size={SIZE.small}
            status={BUTTON_STATUS.ACTIVE}
            textStyle={[TEXT_STYLES.textPrimary100]}
            iconLeft={
              <ApproveIcon width={16} height={16} color={COLORS.primary100} />
            }
          />
        </View>
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  card: {
    ...BG_STYLES.bgWhite,
    ...COMMON_STYLES.p1,
    marginVertical: 4,
    elevation: 2,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  checkbox: {
    borderRadius: 3,
  },
  checkboxContainer: {
    position: "absolute",
    top: 12,
    left: 12,
    zIndex: 1,
  },
});

export default RequestCard;